import { BenefitDTO } from 'probonio-shared-ui/api';
import { ATLunchBenefitDetailsDTO } from 'probonio-shared-ui/api/dto/atlunch-benefit-details-dto';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class ATLunchBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsATLunch = activeBenefit.details as ATLunchBenefitDetailsDTO;
    const possible = detailsATLunch.possibleRefund ?? 0;
    const refund = detailsATLunch.refund ?? 0;

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/at_lunch',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.description`,
      descriptionValues: { amount: Math.max(0, possible - refund) },
      benefitProgress: possible ? 100 : 0,
    };
  }
}
